import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../../commonComponents/translate';
import {
  JOURNEY_STEP_STATUS,
  TROPHY_CONFIG,
} from '../../../../services/utilityFunctions';
import JourneyStepProp from '../../propTypes/journeyStepProp';

function JourneyPathTrophy({ t, step, flipped }) {
  const isLocked = step.status === JOURNEY_STEP_STATUS.LOCKED;

  const containerClass = cx('journey-path-trophy', {
    'invert-row': flipped,
    'journey-path-locked': isLocked,
  });
  const customName =
    step.trophyCustom && step.trophyCustom.name ? step.trophyCustom.name : null;
  const name =
    step.trophy !== 'custom'
      ? t(TROPHY_CONFIG[step.trophy].translationKey)
      : customName;

  const customImage =
    step.trophyCustom && step.trophyCustom.icon
      ? step.trophyCustom.icon.thumb
      : null;
  const image =
    step.trophy !== 'custom'
      ? TROPHY_CONFIG[step.trophy].imageURL
      : customImage;

  return (
    <div className={containerClass}>
      <div className="journey-path-trophy-icon">
        <img src={image} alt="trophy" />
      </div>
      <div className="journey-path-trophy-content">
        <h4>{t('journey_stepType_trophy')}</h4>
        <span>{name}</span>
      </div>
    </div>
  );
}

JourneyPathTrophy.propTypes = {
  t: PropTypes.func.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
  flipped: PropTypes.bool,
};

JourneyPathTrophy.defaultProps = {
  flipped: false,
};

export default translate(JourneyPathTrophy);
